import PropTypes from 'prop-types';
import { Button, Nav } from 'react-bootstrap';

import t from '../../../text';
import { Icon } from '../Icon';
import { useHasScrolledPastThreshold } from './useHasScrolledPastThreshold';

const BOOKING_JOURNEYS = ['/booking/', '/my-booking'];

const HEADER_BAR_HEIGHT = 42;

export const HeaderNavMyBookingButton = ({ onShowMyBooking }) => {
  const { showBasedOnScroll } = useHasScrolledPastThreshold(HEADER_BAR_HEIGHT);
  const isInBookingJourney = BOOKING_JOURNEYS.includes(location.pathname);

  if (isInBookingJourney || !showBasedOnScroll) return null;

  return (
    <Nav className="ml-2">
      <Button type="button" size="sm" variant="grey" onClick={onShowMyBooking}>
        <Icon icon="sign-in" /> {t('header.myBooking')}
      </Button>
    </Nav>
  );
};

HeaderNavMyBookingButton.propTypes = {
  onShowLogin: PropTypes.func,
};
